import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';
import { useTranslate } from '@tolgee/react';

const Container = styled.section`
  width: 320px;
  padding: 0 8px;
  background: #fff;
  border-radius: 4px;
  border: solid 1px #d9e5fd;
  > * {
    padding: 4px 0;
  }
  > header,
  > div {
    border-bottom: solid 1px #f0f2f5;
  }
  > header {
    line-height: 32px;
  }
  > footer {
    font-size: 12px;
    > dl {
      display: flex;
      margin: 4px 0;
      line-height: 18px;
      font-size: 12px;
      color: #515359;
      > dt {
        flex: 0 0 auto;
        margin-right: 4px;
        font-weight: 400;
      }
      > dd {
        flex: 0 0 1;
        margin-bottom: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }
`;

const Product = styled.div`
  display: flex;
  margin: 4px 0;
  > span {
    flex: 0 0 auto;
    margin-right: 8px;
  }
  > div {
    flex: 1 0 0;
  }
`;

const Image = styled.span<{ src: string }>`
  display: inline-block;
  width: 64px;
  height: 64px;
  background: center / cover no-repeat url(${({ src }) => src});
  border-radius: 4px;
`;

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 12px;
  > title {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const Sku = styled.span`
  color: #84868c;
`;

const Extra = styled.div`
  margin-top: 16px;
  > div {
    line-height: 20px;
    font-size: 12px;
    text-align: right;
  }
`;

const Amount = styled.div`
  color: #ee4e2d;
`;

export interface RefundMessageProps extends HTMLAttributes<HTMLDivElement> {
  content: Conversation.MsgRefund;
}

function RefundMessage(props: RefundMessageProps) {
  const { content, ...otherProps } = props;

  const {
    subOrderIcon,
    subOrderTitle,
    subOrderSKU,
    subOrderCount,
    orderTotalCount,
    orderTotalPrice,
    refundOrderId,
    refundOrderDate,
    refundOrderReason,
  } = content;

  const { t } = useTranslate();

  return (
    <Container {...otherProps}>
      <header>{t('ViewsChat.买家发起退款')}</header>
      <div>
        <Product>
          <Image src={subOrderIcon} />
          <ProductInfo>
            <title title={subOrderTitle}>{subOrderTitle}</title>
            <div>
              <Sku>{subOrderSKU}</Sku>
              <span>{`x${subOrderCount}`}</span>
            </div>
          </ProductInfo>
        </Product>
        <Extra>
          <div>{`${t('ViewsChat.退款商品总数')}: ${orderTotalCount}`}</div>
          <Amount>{orderTotalPrice}</Amount>
        </Extra>
      </div>
      <footer>
        <dl>
          <dt>{`${t('ViewsChat.订单号')}:`}</dt>
          <dd>{refundOrderId}</dd>
        </dl>
        <dl>
          <dt>{`${t('ViewsChat.订单时间')}:`}</dt>
          <dd>{refundOrderDate}</dd>
        </dl>
        <dl>
          <dt>{`${t('ViewsChat.退款原因')}:`}</dt>
          <dd title={refundOrderReason}>{refundOrderReason}</dd>
        </dl>
      </footer>
    </Container>
  );
}

export default RefundMessage;
